(() => {
  const init = scope => scope.querySelectorAll('[data-fy-distributor-reference]').forEach(panel => {
    if (panel.dataset.initialized) return;
    panel.dataset.initialized = 'true';
    const form = panel.closest('form');
    if (!form) return;
    const fields = panel.querySelector('[data-fy-reference-fields]');
    const saved = new Map();
    const sync = () => {
      fields.querySelectorAll('[data-fy-unit-reference]').forEach(input => saved.set(Number(input.dataset.fyUnitReference), input.value));
      const quantity = Array.from(form.elements).find(input => input.name === 'quantity');
      const count = Math.max(1, Math.min(99, Math.floor(Number(quantity?.value) || 1)));
      if (fields.children.length === count) return;
      const fragment = document.createDocumentFragment();
      for (let index = 1; index <= count; index++) {
        const label = document.createElement('label');
        label.append(document.createTextNode(panel.dataset.label.replace('{{ number }}', index).replace('%NUMBER%', index)));
        const input = document.createElement('input');
        input.type = 'text';
        input.name = `properties[Riferimento interno eSIM ${index}]`;
        input.maxLength = 120;
        input.placeholder = panel.dataset.placeholder;
        input.dataset.fyUnitReference = index;
        input.value = saved.get(index) || '';
        label.append(input); fragment.append(label);
      }
      fields.replaceChildren(fragment);
      panel.querySelector('[data-fy-reference-count]').value = count;
    };
    document.addEventListener('input', event => { if (event.target.name === 'quantity' && event.target.form === form) sync(); });
    document.addEventListener('change', event => { if (event.target.name === 'quantity' && event.target.form === form) sync(); });
    form.addEventListener('submit', sync, { capture: true });
    sync();
    new MutationObserver(sync).observe(form, { subtree: true, attributes: true, attributeFilter: ['value'] });
  });
  const start = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
